import { useEffect, useState, useLayoutEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheck } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';
import useSignaturePad from '../../hooks/useSignaturePad';
import CardRegisterMRPCModal from './components/CardRegisterMRPCModal';
import CardRegisterMRMCModal from './components/CardRegisterMRMCModal';
import CardWelcomeModal from './components/CardWelcomeModal';
import CustomInput from '../../ui/Form/CustomInput';
import { setDataContract } from './guestsSlice';
import useGetDataOcr from '../../hooks/useGetDataOcr';
import { useCreateGuestMutation } from '../../services/majesticResortsApi';
import { useSendDocumentsMutation, useSendMailMutation } from '../../services/ocrApi';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';
import {
  allowStateResidenceByCountry,
  allowZipCodeByCountry,
  clearCustomFormatter,
  getCountryByCode,
  getDocumentTypeToApi,
  getSexByCode,
  getStateResidenByCode,
  getStringDate,
  replaceDataImage,
} from '../../utils';
import IconPrivacity from '../../assets/new-icons/privacy-policy-min.png';
import IconRecord from '../../assets/new-icons/agreement-min.png';
// import IconAwesomeCheckCircle from '../../assets/icon-awesome-check-circle.svg';
// import IconAwesomeCheckCircle from '../../assets/new-icons/ionic-ios-checkmark-circle-outline.svg';
import IconAwesomeCheckCircle from '../../assets/new-icons/ionic-ios-checkmark-circle-outline-green.svg';
import PrivacyPolicyModal from './components/PrivacyPolicyModal';
import useHotel from '../../hooks/useHotel';
import usePageNavigation from '../../hooks/usePageNavigation';
import ErrorMessageOcrModal from '../../ui/Modals/ErrorMessageOcrModal';

function GuestContractSignPage() {
  const { hotel, language } = useSelector((state) => state.checking);
  const { dataResidence, selectedGuest, guestHolder } = useSelector((state) => state.guests);
  const { documentType, nationality } = useSelector((state) => state.ocr);
  const { booking } = useSelector((state) => state.booking);
  const [showModalRegister, setShowModalRegister] = useState(false);
  const [showModalWelcome, setShowModalWelcome] = useState(false);
  const [showModalPPolicy, setShowModalPPolicy] = useState(false);
  const containerCanvasSignRef = useRef(null);
  const [propertiesSignCanvas, setPropertiesSignCanvas] = useState({
    height: 240,
    width: 500,
    mainBorderSignture: 310,
  });
  const [createGuest, { isError, error }] = useCreateGuestMutation();
  const [sendDocuments, { isError: isErrorSendDocuments, error: errorSendDocuments }] = useSendDocumentsMutation();
  const [sendMail, { isError: isErrorSendMail, error: errorSendMail }] = useSendMailMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // useSelectedGuest();
  const { dataHotel } = useHotel();
  const { OCRData } = useGetDataOcr();

  useLayoutEffect(() => {
    const updateSize = () => {
      if (window.screen.height !== window.innerHeight) {
        setPropertiesSignCanvas({ height: 245, width: containerCanvasSignRef.current.offsetWidth });
      }
    };

    updateSize();

    window.addEventListener('resize', updateSize);

    // const resizeObserver = new ResizeObserver(updateSize);
    // if (containerCanvasSignRef.current) {
    //   resizeObserver.observe(containerCanvasSignRef.current);
    // }

    return () => {
      // resizeObserver.disconnect();
      // Si usas event listener en lugar de ResizeObserver:
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  const { signPad, signRef, sign } = useSignaturePad();

  const {
    control,
    reset,
    trigger,
    register,
    setValue,
    watch,
    formState,
    handleSubmit,
  } = useForm({
    defaultValues: {
      sign: '',
      acceptContract: false,
      acceptWelcome: false,
      acceptAntiDrogs: false,
      acceptTerms: false,
    },
  });

  const { isValid } = formState;

  const {
    ref: refAcceptTerms,
    onChange: onChangeAcceptTerms,
    onBlur: onBlurAcceptTerms,
    name: nameAcceptTerms,
  } = register('acceptTerms', {
    required: true,
  });

  const { navigateNextPage } = usePageNavigation();

  // Observar el checkbox
  const isCheckedContract = watch('acceptContract');
  const isCheckedWelcome = watch('acceptWelcome');

  useEffect(() => {
    const setDataSign = async () => {
      await setValue('sign', sign);
      await trigger();
    };
    setDataSign();
  }, [setValue, trigger, sign]);

  const showAntiDrugs = () => (/*dataResidence.country.iso2 === 'MX' &&*/ (hotel === 'M4' || hotel === 'M5'));

  const onSubmit = async (data) => {
    // 'contract'
    const documentTypeList = ['privacy', 'cardex'];
    let { email, phoneNumber, country, state, zipCode } = dataResidence;

    if (['2', '3'].includes(selectedGuest.TipoPersona)) {
      email = guestHolder.DatosComunicacion.EMail;
      phoneNumber = guestHolder.DatosComunicacion.Telefono;
      country = getCountryByCode(guestHolder.DatosComunicacion.Pais);
      state = getStateResidenByCode(guestHolder.DatosComunicacion.Provincia);
      zipCode = guestHolder.DatosComunicacion.CodigoPostal;
    }

    let newGuest = {
      ...selectedGuest,
      DatosComunicacion: {
        ...selectedGuest.DatosComunicacion,
        // Telefono: dataResidence.phoneNumber,
        Telefono: phoneNumber,
        // Telefono: `+${dataResidence.keyTelephone} ${dataResidence.phoneNumber}`,
        // EMail: dataResidence.email,
        EMail: email,
        // Pais: dataResidence.country.iso2,
        Pais: country.iso2,
      },
      // Email: dataResidence.email,
      Email: email,
      // TODO: DOM que tipo de documento enviar?
      TipoDocumento: getDocumentTypeToApi(documentType),
      PaisNacimiento: nationality.iso2,
    };

    // Para residentes CAN o USA
    if (allowStateResidenceByCountry(country)) {
      newGuest.DatosComunicacion.Provincia = state.iso2State;
    }

    // Para residentes MEX
    if (allowZipCodeByCountry(country)) {
      newGuest.DatosComunicacion.CodigoPostal = zipCode;
    }

    if (showAntiDrugs()) {
      documentTypeList.push('turismo');
    }

    newGuest = clearCustomFormatter(newGuest);

    let params = { d: newGuest };

    await createGuest(params).unwrap();

    const dataSex = getSexByCode(OCRData.gender);

    params = {
      documentTypeList,
      bookingDetails: {
        // email: dataResidence.email,
        email,
        reservationNumber: booking?.NumReserva,
        language: `${language.toLowerCase()}`,
        documentNumber: OCRData.documentNumber,
        dateArrive: booking.FechaEntrada,
        dateDeparture: booking.FechaSalida,
        hotel: booking.HotelFactura,
        hotelName: `${dataHotel.HotelName} ${dataHotel.HotelLocation}`,
        adults: booking.AD?.toString() || '',
        juniors: booking.JR?.toString() || '',
        childs: booking.NI?.toString() || '',
      },
      guestDetails: {
        firstName: selectedGuest.Nombre_Pila,
        lastName: selectedGuest.Nombre,
        typeOfDocument: documentType,
        issuingCountry: nationality[`name${language.toUpperCase()}`],
        issueDate: selectedGuest.FechaExpedicion,
        expirationDate: selectedGuest.FechaCaducidad,
        birthDate: selectedGuest.FechaNacimiento,
        gender: dataSex[`Name${language.toUpperCase()}`],
        phone: phoneNumber,
        countryOfResidence: country?.[`name${language.toUpperCase()}`],
        region: state?.[`name${language.toUpperCase()}`],
        purposeOfStay: booking.MotivoViaje,
      },
      firmaBase64: replaceDataImage(data.sign),
    };

    await sendDocuments(params).unwrap();

    params = {
      mail: email,
      nameGuest: `${selectedGuest.Nombre_Pila} ${selectedGuest.Nombre}`,
      hotel: booking.HotelFactura,
      hotelName: `${dataHotel.HotelName} ${dataHotel.HotelLocation}`,
      dateArrive: getStringDate(booking.FechaEntrada),
      reservationNumber: booking?.NumReserva,
      documentNumber: OCRData.documentNumber,
      language: `${language.toLowerCase()}`,
    };

    await sendMail(params).unwrap();

    // console.log(newGuest);
    dispatch(setDataContract(data));

    // navigate('/Booking');
    navigateNextPage('Booking');
  };

  const onError = (errorList) => {
    console.log(errorList);
  };

  const handleCloseRegister = () => setShowModalRegister(false);
  const handleShowRegister = () => setShowModalRegister(true);

  const handleCloseWelcome = () => setShowModalWelcome(false);
  const handleShowWelcome = () => setShowModalWelcome(true);

  const handleClosePPolicy = () => setShowModalPPolicy(false);
  const handleShowPPolicy = () => setShowModalPPolicy(true);

  const handleClearSign = async () => {
    signPad.clear();
    await setValue('sign', '');
    await trigger();
  };

  return (
    <div className="guest__contract-sign pb-2">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="my-3 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">{t('TXT_CONTRACT')}</p>
      </div>

      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        setValue={setValue}
        watch={watch}
        formState={formState}
        register={register}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="dr__form">
          {hotel !== 'M4' && (
            <CardRegisterMRPCModal
              show={showModalRegister}
              handleClose={handleCloseRegister}
              control={control}
              defaultValue={isCheckedContract}
            />
          )}
          {hotel === 'M4' && (
            <CardRegisterMRMCModal
              show={showModalRegister}
              handleClose={handleCloseRegister}
              control={control}
              defaultValue={isCheckedContract}
            />
          )}

          <Card
            className="border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2"
            onClick={handleShowRegister}
          >
            <Card.Body className="d-flex">
              <div className="text-center my-auto">
                <img
                  src={isCheckedContract ? IconAwesomeCheckCircle : IconRecord}
                  alt="IconPrivacity"
                  className="img-fluid-33"
                />
              </div>
              <div className="flex-fill ps-3 pe-2">
                <p className="mb-0 app-lh-h6 app-fw-notosans-bold app-txt-granite-80">
                  {t('TXT_ACCOMMODATION_CONTRACT')}
                </p>
                <p
                  className={`mb-0 app-lh-h6 app-fs-12 ${isCheckedContract ? 'app-txt-green app-fw-notosans-bold' : 'app-txt-granite-80-dark app-fw-notosans-light'}`}
                >
                  {isCheckedContract ? t('TXT_VALIDATED_ACCEPTANCE') : t('TXT_PENDING_ACCEPTANCE')}
                </p>
              </div>
              <div className="text-end my-auto">
                <p className="mb-0 app-txt-gold">
                  <FontAwesomeIcon icon={faChevronRight} />
                </p>
              </div>
            </Card.Body>
          </Card>

          {showAntiDrugs() && (
            <CardWelcomeModal
              show={showModalWelcome}
              handleClose={handleCloseWelcome}
              control={control}
              defaultValue={isCheckedWelcome}
            />
          )}
          <Card
            className={`border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2 ${showAntiDrugs() ? '' : 'd-none'}`}
            onClick={handleShowWelcome}
          >
            <Card.Body className="d-flex">
              <div className="text-center my-auto">
                <p className="mb-0">
                  <img
                    src={isCheckedWelcome ? IconAwesomeCheckCircle : IconPrivacity}
                    alt="IconPrivacity"
                    className="img-fluid-33"
                  />
                </p>
              </div>
              <div className="flex-fill ps-3 pe-2">
                <p className="mb-0 app-lh-h6 app-fw-notosans-bold app-txt-granite-80">
                  {t('TXT_TITLE_NOTICE')}
                  :
                  {' '}
                  {t('TXT_ANTIDROGS_MINISTRY_TOURISM')}
                </p>
                <p
                  className={`mb-0 app-lh-h6 app-fs-12 ${isCheckedWelcome ? 'app-txt-green app-fw-notosans-bold' : 'app-txt-granite-80-dark app-fw-notosans-light'}`}
                >
                  {isCheckedWelcome ? t('TXT_VALIDATED_ACCEPTANCE') : t('TXT_PENDING_ACCEPTANCE')}
                </p>
              </div>
              <div className="text-end my-auto">
                <p className="mb-0 app-txt-gold">
                  <FontAwesomeIcon icon={faChevronRight} />
                </p>
              </div>
            </Card.Body>
          </Card>

          <Card
            ref={containerCanvasSignRef}
            className="bg-tranparent border-0 mt-3"
          >
            <Card.Body className="d-flex p-0">
              <div className="mx-auto main-border-signature">
                <div
                  className="w-100 d-flex align-items-center justify-content-center my-0 rounded-3"
                  style={{ backgroundColor: '#f4f4f4' }}
                >
                  <div className="opacity-25 position-absolute text-center">
                    <p className="mb-0 app-fw-notosans-bold app-fs-h4 app-lh-h4">{t('TXT_SIGN_HERE')}</p>
                    <p className="mb-0 w-75 mx-auto">{t('TXT_SAME_DOCUMENT_SIGNATURE')}</p>
                  </div>
                  <CustomInput
                    control={control}
                    name="sign"
                    typeInput="hidden"
                    rules={{ required: true }}
                    classNames={{ card: 'd-none' }}
                  />
                  <canvas
                    ref={signRef}
                    width={propertiesSignCanvas.width}
                    className="z-1 border border-solid-1 app-border-granite-80-light rounded-3"
                    height={propertiesSignCanvas.height}
                  />
                </div>
              </div>
            </Card.Body>
            <Card.Footer className="d-flex px-0 pb-0 bg-transparent border-0 pt-0">
              <div className="my-auto">
                <p className="mb-0 app-fs-14 app-fw-notosans-regular">{t('TXT_SIGN_ACCEPTANCE_CONTRACT')}</p>
              </div>
              <div className="text-end flex-fill">
                <Button
                  variant="link"
                  type="button"
                  onClick={() => handleClearSign()}
                  className="bg-transparent app-fs-14 app-fw-notosans-bold app-txt-gold p-0 btn-link-height border-0"
                >
                  {t('TXT_BOTON_DELETE')}
                </Button>
              </div>
            </Card.Footer>
          </Card>

          <PrivacyPolicyModal
            show={showModalPPolicy}
            handleClose={handleClosePPolicy}
          />
          <Form.Check className="mb-3 ps-0" type="checkbox" id="acceptRegisterAndWelcome">
            <Form.Check.Label className="custom-input-checkbox">
              <Form.Check.Input
                ref={refAcceptTerms}
                onChange={onChangeAcceptTerms}
                // onBlur={onBlurBooking}
                name={nameAcceptTerms}
                // checked={value}
                type="checkbox"
              />
              {/* <span className="checkmark" /> */}
              <span className="checkmark">
                <FontAwesomeIcon icon={faCheck} />
              </span>
              <Button
                onClick={handleShowPPolicy}
                variant="link"
                type="button"
                className="bg-transparent app-fs-12 app-fw-notosans-bold app-txt-gold p-0 btn-link-height border-0"
              >
                {t('TXT_PRIVACY_POLICY')}
              </Button>
              {/* <span onClick={handleShowPPolicy} className="label-text fw-normal text-decoration-underline app-fs-12">{t('TXT_PRIVACY_POLICY')}</span> */}
            </Form.Check.Label>
          </Form.Check>

          <div className="mt-3">
            <Button
              variant=""
              type="submit"
              disabled={!isValid}
              className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
            >
              {t('TXT_BOTON_CONTINUE')}
            </Button>
          </div>
        </Form>
      </FormProvider>
      {isError && <MessageErrorModal message={error.message} />}
      {/* {isErrorSendDocuments && <MessageErrorModal message={errorSendDocuments.message} />} */}
      {isErrorSendDocuments && <ErrorMessageOcrModal />}
      {/* {isErrorSendMail && <MessageErrorModal message={errorSendMail.message} />} */}
      {isErrorSendMail && <ErrorMessageOcrModal />}
    </div>
  );
}

export default GuestContractSignPage;
